/** @jsxImportSource @emotion/react */

import { css } from '@emotion/react';
import React from 'react';
import { shopNowBtn } from '../Styles/ButtonStyles';

// interface ButtonProps{
//     styles: string;
// }
const Button = (): JSX.Element => {
    return (
        <div css={shopNowBtn}>
            <p style={{ color: 'white', fontFamily: 'AcuminRPro', margin: 0 }}>Shop Now</p>
            <img className='arrow' src='/assets/icons/ArrowRight.png' alt='arrow-right' />
        </div>
    );
};

export default Button;
